var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ol',{staticClass:"steps"},_vm._l((_vm.steps),function(item){return _c('li',{key:item,staticClass:"step",class:[{ 'is-complete': item < _vm.currentStep }, { 'is-active': item === _vm.currentStep }],attrs:{"data-step":item},on:{"click":function($event){return _vm.$emit('setStep', item)}}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }